import { useState } from 'react'
import { TirePhotoPosition, TireCondition } from '../../../api-client/enums'
import Image, { Zoomable } from '../../../components/image'
import Modal from '../../../components/modal'

const TirePhotoNames = {
  [TirePhotoPosition.FrontDriverSide]: 'Front Driver Side Tire',
  [TirePhotoPosition.RearDriverSide]: 'Rear Driver Side Tire',
  [TirePhotoPosition.FrontPassengerSide]: 'Front Passenger Side Tire',
  [TirePhotoPosition.RearPassengerSide]: 'Rear Passenger Side Tire',
}

const conditionOfTire = {
  [TireCondition.Fail]: 'Fail',
  [TireCondition.Pass]: 'Pass',
}

export default function Tires({ photos }) {
  const [photoPreview, setPhotoPreview] = useState(false)

  return (
    <div className='wrapper'>
      {!!photoPreview && (
        <Modal onClose={() => setPhotoPreview(false)}>
          <div className='previewContainer'>
            <p className='angle visible'>{TirePhotoNames[photoPreview.position]}</p>
            <div className='photoPreview flex alignEnd'>
              <Zoomable src={photoPreview.url} alt='tire' width='1440' height='810' />
            </div>
          </div>
        </Modal>
      )}

      {photos &&
        photos.map((tire) => (
          <div className='line flex alignCenter' key={tire.id}>
            <p className='tireName'>{TirePhotoNames[tire.position]}</p>
            <div className='flex alignCenter'>
              <Image
                src={tire.url}
                alt='tire'
                onClick={() => setPhotoPreview(tire)}
                width='70'
                height='70'
              />
              <span>
                {tire.brand}, {conditionOfTire[tire.condition]}
              </span>
            </div>
          </div>
        ))}
      <style jsx>{`
        .wrapper {
          width: 100%;

          :global(img) {
            width: 4.3rem;
            height: 4.3rem;
            margin: 0 1.2rem 0 0;
            border-radius: 50%;
            cursor: pointer;
            object-fit: cover;
          }
        }

        .line {
          width: 100%;
          padding: 3.2rem 0;
          border-bottom: 1px solid var(--secondary-text-color);

          &.line:last-child {
            border-bottom: 0;
          }
        }

        .tireName {
          width: 40%;
          font-size: 1.8rem;
        }

        span {
          font-size: 1.8rem;
          font-weight: 700;
        }

        .photoPreview {
          border-radius: 1rem;
          background: rgba(0, 0, 0, 0.1);
          height: calc(70vh + 5rem);

          :global(div > div > img) {
            height: 70vh;
            max-width: 80vw;
            width: auto;
            object-fit: contain;
            object-position: center;
            margin: unset;
            border-radius: 1rem;
          }
        }

        .angle {
          position: absolute;
          top: 1rem;
          left: 0;
          width: 100%;
          text-align: center;
          color: #fff;
          font-weight: 700;
          font-size: 2.4rem;
        }

        @media (min-width: 1025px) and (max-width: 1364px) {
          .line {
            padding: 2.6rem 0;
          }
        }

        @media (max-width: 1024px) {
          .previewContainer {
            width: 100%;
            height: 100%;
            background: #000;
          }

          .line {
            flex-direction: column;
            align-items: flex-start;
            padding: 1.2rem 0;
          }

          .tireName {
            margin: 0 0 1.2rem;
          }

          .tireName,
          span {
            font-size: 1.4rem;
          }

          .photoPreview {
            display: flex;
            justify-content: center;
            position: absolute;
            top: 45%;
            transform: translateY(-50%);
            width: 100%;
            height: 21.2rem;
            background: none;
            border-radius: 0;

            :global(img) {
              border-radius: 0;
              height: 100%;
            }
          }

          .angle {
            top: 4.2rem;
            font-size: 1.4rem;
          }
        }
      `}</style>
    </div>
  )
}
